<template>
    <div>
        <card-header title='New Registration Type/Fee' icon="fa-plus"/>

        <card-body>
            <conf-type-form :type="newType" :conference-id="props.confId"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!newType.title || !newType.fee"
                    ><i class="fas fa-plus mr-2"></i>New Type/Fee</b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import ConfTypeForm from "./TypeForm";

    import {client as http} from "@/http_client";
    import moment from "moment/moment";

    export default {
        components: {ConfTypeForm, CardHeader, CardToolbar, CardBody, CardFooter},
        props: ['card', 'props'],
        data() {
            return {
                conference: {},
                newType: {
                    fee: '0',
                    cc_surcharge: '0',
                    cc_surcharge_info: '0',
                    cc_fee: '0',
                    po_fee: '0',
                    org_share: '0',
                    self_share: '0',
                    hour_limit: '0'
                }
            }
        },
        methods: {
            loadConference: function () {
                this.$emit('loading', true);
                http.get('conferences/' + this.props.confId, {force: true}).then(response => {
                    this.conference = response.data;

                    this.newType.cc_surcharge = this.conference.default_cc_surcharge;
                    this.newType.cc_surcharge_info = this.conference.default_cc_surcharge_info;
                    this.newType.cc_fee = this.conference.default_cc_fee;
                    this.newType.po_fee = this.conference.default_po_fee;
                    this.newType.org_share = this.conference.default_org_share;
                    this.newType.self_share = this.conference.default_self_share;

                    console.log(this.newType)

                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            submit: function() {
                this.$emit('loading', true);
                const payload = {
                    ...this.newType,
                    conference_id: this.props.confId
                };

                // Include tax fields if they are set
                if (this.newType.tax_rate !== null && this.newType.tax_rate !== undefined) {
                    payload.tax_rate = this.newType.tax_rate;
                    payload.tax_state_rate = this.newType.tax_state_rate;
                    payload.tax_local_rate = this.newType.tax_local_rate;
                    payload.tax_jurisdiction = this.newType.tax_jurisdiction;
                    payload.tax_location_code = this.newType.tax_location_code;
                }

                http.post('/conferences/' + this.props.confId + '/types', payload, {force: true}).then(response => {
                    this.$reloadCard('conference', {confId: this.props.confId});
                    this.$reloadCard('conf-reg-types', {confId: this.props.confId});
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the conference fee.');
                    this.$emit('loading', false);
                });
            }
        },
        mounted() {
            this.loadConference();
        }
    }
</script>
